import { useState, useEffect, useCallback } from 'react';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography
} from "@mui/material";
import { useSnackbar } from 'notistack';

import contact_img from '~/assets/images/contact_img.png';
import ListArticle from "../components/ListArticle";
import ExamSessionServices from "../services/ExamSessionServices";


const ExamPlan = () => {
    const [listExam, setListExam] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const showAlert = useCallback((message, variant) => {
        enqueueSnackbar(message, { variant });
    }, [enqueueSnackbar]);

    const getExam = useCallback(async () => {
        try {
            let response = await ExamSessionServices.getExamOfYear()
            if (response) {
                setListExam(response);
            }
        } catch (error) {
            showAlert("Lỗi khi tải danh sách kỳ thi!", "error");
            console.log(error);
        }
    }, [showAlert]);

    useEffect(() => {
        getExam();
    }, [getExam]);

    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 250,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center'

                }}>
                KẾ HOẠCH THI
            </Box>
            <ListArticle category='Kế hoạch thi' />
            <Box sx={{ maxWidth: "lg", marginInline: "auto", mt: 4, p: 2 }}>

                <Typography variant="h5" sx={{ textAlign: "center", fontWeight: "Bold", color: "var(--primary)" }}>
                    CÁC KỲ THI TRONG NĂM {new Date(Date.now()).getFullYear()}
                </Typography>
                <TableContainer component={Paper} sx={{ mt: 4 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    TT
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Tên kỳ thi
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Hạn nộp HS
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Ngày thi
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Công bố KQ
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Phúc khảo
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 18 }}>
                                    Trạng thái
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listExam.map((row, index) => (
                                <TableRow
                                    key={index}
                                >
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {++index}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {row?.name}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {new Date(row?.regisEndDate).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {new Date(row?.examDay).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {new Date(row?.dateAnnounResults).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {new Date(row?.reEvalDate).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 16 }}>
                                        {row?.isOpen ? "Mở đăng ký" : "Đóng đăng ký"}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>

    )
}

export default ExamPlan;